import authenticatedAxios from '@/commons/configuration/authenticated.axios'
import { ENVIRONMENT } from '@/commons/configuration'
import { ErrorUtils } from '@/commons/utils/error'

export class CourierService {
    static async fetchCourierPrice (country: string | null, city: string | null, postalCode: string | null): Promise<string> {
        try {
            const price = await authenticatedAxios.get(ENVIRONMENT.courierPriceUrl, {
                params: {
                    destinationCity: city,
                    destinationCountry: country,
                    destinationPostalCode: postalCode
                }
            })
            return price.data
        } catch (e) {
            throw ErrorUtils.resolveRequestErrorEntity(e)
        }
    }
}
